
import { mapGetters } from "vuex";
import HeaderV2 from "~/components/v2/common/header/header-v2.vue";

const reviewedPages = [
  "escorts-updates",
  "escorts-updates-slug",
  "categories-gender",
  "escorts-videos",
  "reviews",
];

export default {
  name: "Default",

  components: {
    HeaderV2,
    BookMeModal: () =>
      import("~/components/v2/modals/profiles/book-me-modal.vue"),
  },

  middleware: ["isActive"],

  // data() {
  //   return {
  //     headerHeight: null,
  //   };
  // },

  computed: {
    ...mapGetters({
      headerHidden: "global/getPaddingForHiddenHeader",
    }),

    renderInsideApp() {
      return reviewedPages.includes(this.$route.name);
    },

    // headerCSSVars() {
    //   return {
    //     "--header-height": `${this.headerHeight}px`,
    //   };
    // },
  },

  // watch: {
  //   $route() {
  //     this.setPagePadding();
  //   },
  // },

  mounted() {
    if (this.$auth.loggedIn) {
      this.$store.dispatch("notifications/retrieveSidebarNotifications");
    }

    this.$root.$on("book-me-modal:open", (slug) => {
      this.$refs.bookMeModal.open(slug);
    });
    // this.$root.$on("set-page-padding", () => {
    //   this.setPagePadding();
    // });
  },

  beforeDestroy() {
    this.$root.$off("book-me-modal:open");
  },

  // methods: {
  //   setPagePadding() {
  //     if (!this.$refs.header) return;
  //     this.headerHeight =
  //       this.$refs.header.$el.querySelector("header").clientHeight;
  //   },
  // },
};
